export function renderSelectLabelLabelTemplate({
  valueExpression
}: {
  valueExpression: string
}): string {
  return `const label = Array.isArray(${valueExpression})
        ? ${valueExpression}
            .map((option) =>
              typeof option === 'object' && option !== null && 'label' in option
                ? String(option.label)
                : String(option)
            )
            .join(', ')
        : ${valueExpression} === null || ${valueExpression} === undefined
          ? null
          : String(${valueExpression})`
}
